import ApiService from "@/common/api.service";

export const CatIIRequirementService = {
  create(params) {
    return ApiService.post("catIIRequirement/add", params);
  },
  update(slug, params) {
    return ApiService.update("catIIRequirement", slug, params);
  },
};
